export default {"src":"/_next/static/media/instagram-icon-27-27.34692cd9.svg","height":27,"width":27};